import { DecoratorNode } from 'lexical';

import Spinner from 'shopper/components/Spinner';

import { getYTVideoId } from 'lib/utils';

import THIRD_PARTY from 'constants/thirdParty';

class VideoNode extends DecoratorNode {
  __height;
  __width;
  __videoId;

  constructor(src, height, width, key) {
    super(key);

    this.__videoId = getYTVideoId(src);
    this.__height = height ?? 'inherit';
    this.__width = width ?? 'inherit';
  }

  static clone({ src, height, width, key }) {
    return new VideoNode(src, height, width, key);
  }

  static getType() {
    return 'video';
  }

  static importDOM() {
    return {
      iframe: () => ({
        conversion: convertVideoElement,
        priority: 0,
      }),
    };
  }

  createDOM() {
    return document.createElement('div');
  }

  exportDOM() {
    return { element: this.src };
  }

  updateDOM() {
    return false;
  }

  static importJSON({ height, src, width }) {
    return $createVideoNode({ height, src, width });
  }

  exportJSON() {
    return {
      height: this.height,
      src: this.src,
      type: 'video',
      width: this.width,
    };
  }

  get src() {
    return `https://www.youtube.com/watch?v=${this.__videoId}`;
  }

  get height() {
    return this.__height.toString();
  }

  get width() {
    return this.__width.toString();
  }

  decorate() {
    const src = `https://www.youtube.com/embed/${this.__videoId}${THIRD_PARTY.YT_PARAMS}`;

    return (
      <div className="relative w-fit min-w-24">
        <div className="absolute left-1/2 top-1/2 z-1">
          <Spinner />
        </div>
        <iframe
          allow={THIRD_PARTY.IFRAME_PERMISSIONS}
          className="relative z-2 max-h-40 w-auto border-none"
          height={this.height}
          src={src}
          title="iniciar video"
          width={this.width}
          allowFullScreen
          autoplay
        />
      </div>
    );
  }
}

const convertVideoElement = (domNode) => {
  if (domNode instanceof HTMLVideoElement) {
    const { src, height, width } = domNode;

    return {
      node: $createVideoNode({ src, height, width }),
    };
  }

  return null;
};

export const $createVideoNode = ({ src, height, width, key }) =>
  new VideoNode(src, height, width, key);

export const $isVideoNode = (node) => node instanceof VideoNode;

export const $addVideoNodeConfig = (nodes) => {
  nodes.push(VideoNode);
};

export default VideoNode;
